import * as React from 'react';
import { useSelector } from 'react-redux';

import { IAppState } from '../../../common/state';
import { useApplicationContext } from '../../../utils/applicationContext';
import { HeaderDeveloperRedesigned } from '../../components/HeaderDeveloperRedesigned';
import { HeaderDeveloper } from '../../components/header/developer/index';

export const HeaderDeveloperContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const breadcrumbs = useSelector((state: IAppState) => state.breadcrumbs);
  const developerInfo = useSelector((state: IAppState) => state.results.developerInfo);

  const isRedesignEnabled = config.get<boolean>('Newbuilding.SerpDeveloperHeader.Enabled');

  /* istanbul ignore if */
  if (!developerInfo) {
    return null;
  }

  if (isRedesignEnabled) {
    return <HeaderDeveloperRedesigned developerInfo={developerInfo} breadcrumbs={breadcrumbs} />;
  }

  return <HeaderDeveloper breadcrumbs={breadcrumbs} developerInfo={developerInfo} />;
};
